import { OODocumentations } from '../interfaces';

import { OODocumentModel } from './DocumentModel';

interface ConstructorParams {
  name: OODocumentations;
  label: string;
  description: string;
  groupDocuments: boolean;
  isProfilePhoto: boolean;
  hideTakePhotoButton?: boolean;
  isMandatory: boolean;
  uploadEarly?: boolean;
  isMultipleDocumentsEnabled: boolean;
  uploadableByCandidate: boolean;
  documents: OODocumentModel[];
  mandatoryCondition?: [];
  statusIcon?: React.ReactNode;
  statusHeader?: string;
  hasReminder?: boolean;
  reminderLabel?: string;
}

export class OODocumentationModel {
  public name: OODocumentations;
  public label: string;
  public description: string;
  public isProfilePhoto: boolean;
  public hideTakePhotoButton?: boolean;
  public groupDocuments: boolean;
  public isMandatory: boolean;
  public isMultipleDocumentsEnabled: boolean;
  public uploadableByCandidate: boolean;
  public documents: OODocumentModel[];
  public uploadEarly?: boolean;
  public mandatoryCondition?: [];
  public statusIcon?: React.ReactNode;
  public statusHeader?: string;
  public hasReminder?: boolean;
  public reminderLabel?: string;

  constructor({
    name,
    label,
    description,
    isProfilePhoto,
    groupDocuments,
    isMandatory,
    isMultipleDocumentsEnabled,
    uploadableByCandidate,
    uploadEarly,
    documents,
    hideTakePhotoButton,
    mandatoryCondition,
    statusIcon,
    statusHeader,
    hasReminder,
    reminderLabel,
  }: ConstructorParams) {
    this.name = name;
    this.label = label;
    this.description = description;
    this.groupDocuments = groupDocuments;
    this.isProfilePhoto = isProfilePhoto;
    this.hideTakePhotoButton = hideTakePhotoButton;
    this.isMandatory = isMandatory;
    this.isMultipleDocumentsEnabled = isMultipleDocumentsEnabled;
    this.documents = documents;
    this.uploadableByCandidate = uploadableByCandidate;
    this.uploadEarly = uploadEarly;
    this.mandatoryCondition = mandatoryCondition;
    this.statusIcon = statusIcon;
    this.statusHeader = statusHeader;
    this.hasReminder = hasReminder;
    this.reminderLabel = reminderLabel;
  }

  public static fromJson(json: any) {
    const {
      name,
      label,
      description,
      isProfilePhoto,
      isMandatory,
      isMultipleDocumentsEnabled,
      uploadableByCandidate,
      groupDocuments,
      hideTakePhotoButton,
      uploadEarly,
      mandatoryCondition,
      hasReminder,
      reminderLabel,
    } = json;
    const documents = (json.documents || []).map((doc: OODocumentModel) => OODocumentModel.fromJson(doc));
    return new OODocumentationModel({
      name,
      label,
      description,
      groupDocuments,
      isProfilePhoto,
      isMandatory,
      isMultipleDocumentsEnabled,
      uploadableByCandidate,
      documents,
      hideTakePhotoButton,
      uploadEarly,
      mandatoryCondition,
      hasReminder,
      reminderLabel,
    });
  }
}
